"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class ProductService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'products';
        /**
         * Obtiene el catálogo de productos.
         */
        this.getProducts = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene un producto en base al id.
         * @param id. (Number) 'id del producto'.
         */
        this.getProductById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene un producto por referencia.
         * @param productTypeId. (Number) 'id del tipo de producto'.
         * @param referenceId. (Number) 'referencia del producto'.
         */
        this.getProductByReferenceId = async (productTypeId, referenceId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/by-reference/${productTypeId}/${referenceId}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener un programa por id (new version Sku)
         * @param id (Number) 'Id del Programa'
         * @returns  (Object) 'Programa'
         */
        this.getProgramById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/programs/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener las membresas activas  (new version Sku)
         * @param id (Number) 'Id del Programa'
         * @returns  (Object) 'Programa'
         */
        this.getActiveMemberships = async (person_id = 0, program_id = 0, course_id = 0) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/memberships?person_id=${person_id}&program_id=${program_id}&course_id=${course_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener un curso por id (new version Sku)
         * @param id (Number) 'Id del Curso'
         * @returns  (Object) 'Curso'
         */
        this.getCourseById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/courses/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener las membresías de harmon hall
         * @param membershipSKU (String) 'SKU de la membresía talisis'
         * @returns  (Array) 'Arreglo de productos Harmon Hall'
         */
        this.getHarmonHallMemberships = async (membershipSKU) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/harmon-hall-memberships?membership_sku=${membershipSKU}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener las productos de membresias por referencia y meses
         * @param term_months (number) 'Numero de meses membresia'
         * @param reference_id (number) 'Referencia de la membresia'
         * @returns  (Array) 'Arreglo de membresia encontrada en productos'
         */
        this.getProductByMembershipReference = async (term_months, reference_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/membership/${term_months}/${reference_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtener las membresías de harmon hall
         * @param slug (String) 'SKU pattern del producto'
         * @returns  (Array) 'Arreglo de productos encontrados por el pattern sku'
        */
        this.getProductsBySkuPattern = async (slug) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/pattern-sku/${slug}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Inscribe productos al usuario
         * @param body (Object) 'Cuerpo de la petición: person_id, program_id, course_id.'
         * @returns (Object) 'Resultado de la petición: success, message.'
        */
        this.postProductEnrollment = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/enrollment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.ProductService = ProductService;
